/* Eco Fees – recalcul automatique (ajout/modif/checkout)
   ------------------------------------------------------ */

const ECO_FEE_LEQ33_VARIANT_ID = 51726581235893;  // ≤33"
const ECO_FEE_GT33_VARIANT_ID  = 51726581268661;  // >33"
const EXCLUDED_VENDORS         = ["Techno Pneu"]; // sans écofrais

// ---------- helpers ----------
const toNum = (x) => { const v = parseFloat(String(x).replace(",", ".")); return isNaN(v) ? null : v; };
const inchesFromMetric = (w,a,r) => {
  const W = toNum(w), A = toNum(a), R = toNum(r);
  if (W==null || A==null || R==null) return null;
  return (2*(W*(A/100)) + (R*25.4)) / 25.4;
};

/* Extraction robuste du diamètre en pouces à partir du titre/variant_title.
   Gère:
   - P-metric / LT / ST / T : P195/60R15, LT235/75R15, 195/60-15, 225/40ZR18
   - Flotation / impérial   : 35x12.50R17, 35/12.5-17
   - Mention directe pouces : 33", 33 IN, 33 po
*/
const diameterFromVariantTitle = (title) => {
  if (!title) return null;
  const t = String(title).toUpperCase();
  const noSpaces = t.replace(/\s+/g, "");

  // 1) P-metric / LT / ST / T (prefixe optionnel) + séparateur (R|ZR|-)
  //    Ex: P195/60R15, LT235/75R15, 195/60-15, 225/40ZR18
  let m = noSpaces.match(/\b(?:LT|P|ST|T)?(\d{3})\/(\d{2})(?:ZR|R|-)?(\d{2})\b/);
  if (m) return inchesFromMetric(m[1], m[2], m[3]);

  // 2) Flotation/impérial : on retourne le diamètre directement (ex: 35x12.50R17, 35/12.5-17)
  m = noSpaces.match(/\b(\d{2,3})(?:X|×|\/)(\d{1,2}(?:\.\d{1,2})?)(?:R|-)?(\d{2})\b/);
  if (m) return toNum(m[1]) ?? null;

  // 3) Mention directe en pouces : 33", 33 IN, 33 PO
  m = t.match(/\b(\d{2,3})\s*(?:IN|PO|")\b/);
  if (m) return toNum(m[1]) ?? null;

  return null;
};

const isEcoFeeVariant = (vid) => {
  const id = Number(vid);
  return id === Number(ECO_FEE_LEQ33_VARIANT_ID) || id === Number(ECO_FEE_GT33_VARIANT_ID);
};
const chooseEcoId = (dIn) => (dIn==null ? null : (dIn<=33 ? ECO_FEE_LEQ33_VARIANT_ID : ECO_FEE_GT33_VARIANT_ID));

const cartGet = () => fetch("/cart.js",{headers:{Accept:"application/json"}}).then(r=>r.json());
const cartAdd = (items) => fetch("/cart/add.js",{
  method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
  body: JSON.stringify({items})
});
const cartChangeByKey = (key, qty) => fetch("/cart/change.js",{
  method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
  body: JSON.stringify({id:key, quantity:qty})
});

// ---------- recalcul écofrais ----------
let RECALC_LOCK = false;
let RECALC_PENDING = false;   // <- nom correct

async function recalcEcoFees() {
  if (RECALC_LOCK) { RECALC_PENDING = true; return; }   // <- correct
  RECALC_LOCK = true;
  try {
    const cart = await cartGet();

    let needLeq33 = 0, needGt33 = 0;
    for (const line of cart.items) {
      if (isEcoFeeVariant(line.variant_id)) continue;
      const vendor = (line.vendor||"").trim().toLowerCase();
      const excluded = EXCLUDED_VENDORS.some(v => v.toLowerCase() === vendor);
      if (excluded) continue;
      const dIn = diameterFromVariantTitle(line.variant_title || line.title || "");
      if (dIn==null) continue;
      if (dIn<=33) needLeq33 += line.quantity; else needGt33 += line.quantity;
    }

    // état actuel
    let haveLeq33 = 0, haveGt33 = 0;
    const ecoKeys = [];
    for (const line of cart.items) {
      if (!isEcoFeeVariant(line.variant_id)) continue;
      ecoKeys.push(line.key);
      if (Number(line.variant_id)===Number(ECO_FEE_LEQ33_VARIANT_ID)) haveLeq33 += line.quantity;
      if (Number(line.variant_id)===Number(ECO_FEE_GT33_VARIANT_ID))  haveGt33  += line.quantity;
    }

    if (haveLeq33===needLeq33 && haveGt33===needGt33) return; // rien à faire

    // nettoyer
    for (const k of ecoKeys) { await cartChangeByKey(k, 0); }
    // reposer
    const toAdd = [];
    if (needLeq33>0) toAdd.push({id:Number(ECO_FEE_LEQ33_VARIANT_ID), quantity: needLeq33});
    if (needGt33>0)  toAdd.push({id:Number(ECO_FEE_GT33_VARIANT_ID),  quantity: needGt33});
    if (toAdd.length) await cartAdd(toAdd);

    document.dispatchEvent(new CustomEvent("cart:updated"));
  } finally {
    RECALC_LOCK = false;
    if (RECALC_PENDING) {
      RECALC_PENDING = false;
      setTimeout(recalcEcoFees, 120);
    }
  }
}

// ---------- hooks ----------
function wireAddToCart() {
  document.querySelectorAll('form[action^="/cart/add"]').forEach($f=>{
    if ($f.dataset.ecoAddWired==="1") return;
    $f.dataset.ecoAddWired="1";
    $f.addEventListener("submit", ()=>{
      // laisser le thème faire l’ajout puis recalcul
      setTimeout(recalcEcoFees, 300);
    });
  });
}

let debounceTimer=null;
const debounceRecalc=()=>{ clearTimeout(debounceTimer); debounceTimer=setTimeout(recalcEcoFees,300); };

function wireCartQuantityWatch(){
  const cartForm=document.querySelector('form[action="/cart"]');
  if (!cartForm || cartForm.dataset.ecoWatch==="1") return;
  cartForm.dataset.ecoWatch="1";
  cartForm.addEventListener("change",(e)=>{
    const t=e.target;
    if (t && (t.name==="updates[]" || t.name==="quantity")) debounceRecalc();
  });
  cartForm.addEventListener("submit",()=> setTimeout(recalcEcoFees,300));
}

// Intercepte checkout mais GARANTIT la redirection/soumission
function wireCheckoutGuard(){
  const selectors=[
    'form[action="/cart"] [name="checkout"]',
    'a[href="/checkout"]',
    'button[name="checkout"]',
    'button[data-testid="Checkout-button"]'
  ];
  document.querySelectorAll(selectors.join(",")).forEach(btn=>{
    if (btn.dataset.ecoCheckout==="1") return;
    btn.dataset.ecoCheckout="1";
    btn.addEventListener("click", async (e)=>{
      // capture cible pour redirection sûre
      const el=e.currentTarget;
      const isLink=el.tagName==="A";
      const form=el.closest("form");
      e.preventDefault();

      let timedOut=false;
      const timeout = new Promise(res=>setTimeout(()=>{ timedOut=true; res(); }, 2000));
      // on tente un recalcul mais on ne bloque pas plus de 2s
      await Promise.race([recalcEcoFees(), timeout]).catch(()=>{});

      // Redirige quoi qu’il arrive
      if (isLink) {
        window.location.href="/checkout";
      } else if (form) {
        // évite boucle : on retire temporairement le handler
        btn.dataset.ecoCheckout="2";
        form.submit();
      } else {
        window.location.href="/checkout";
      }
    });
  });
}

// Observer pour DOM dynamique (drawer, etc.)
const mo=new MutationObserver(()=>{
  wireAddToCart(); wireCartQuantityWatch(); wireCheckoutGuard();
});
mo.observe(document.documentElement,{childList:true,subtree:true});

// Init
document.addEventListener("DOMContentLoaded", ()=>{
  wireAddToCart(); wireCartQuantityWatch(); wireCheckoutGuard();
  setTimeout(recalcEcoFees, 200);
});
document.addEventListener("shopify:section:load", ()=>{
  wireAddToCart(); wireCartQuantityWatch(); wireCheckoutGuard();
  setTimeout(recalcEcoFees, 200);
});
document.addEventListener("cart:updated", debounceRecalc);
